<template>
    <div class="step --skin-type">
        <h1 class="step__question">What's your skin type?</h1>

        <ul class="step__answers-wrapper --skin-type">
            <li v-for="(skin_type,i) in options" class="step__answer --skin-type" :key="i">
                <div @click="concern = i" :class="{ '--chosen': concern === i }">
                    <span>{{ skin_type }}</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { bus } from '../../utilities'
    import logic from '../../data/logic'

    export default {
        name: 'SkinTypes',
        data() {
            return {
                options: logic.quiz[3].options,
                concern: null
            }
        },
        watch: {
            concern() {
                this.answer(this.concern)
            }
        },
        methods: {
            answer(i) {
                bus.$emit('answer::chosen', i)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// source/app/js/components/sections/skin-type.vue